import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TooltipViewportPosition } from '@tripointe/tripointe-cms/types';

import { TooltipService } from './tooltip.service';

@Component({
  selector: 'tp-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TooltipComponent implements OnInit, OnDestroy {
  showTooltip: TooltipViewportPosition;
  private unsubscribe$: Subject<boolean> = new Subject();

  constructor(private tooltipService: TooltipService) {}

  ngOnInit(): void {
    this.subscribeToTooltipActions();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  private subscribeToTooltipActions(): void {
    this.tooltipService.showTooltip.pipe(takeUntil(this.unsubscribe$)).subscribe(action => {
      this.showTooltip = action;
    });
  }
}
